import React, { useEffect, useState } from 'react';
import { Table } from 'components/UI';
import i18n from 'i18n-js';
import { groupBy, filter } from 'lodash';
import { capitalize } from 'utils';

const OptionalItemsTable = ({ pricing }) => {
  const [data, setData] = useState({});

  useEffect(() => {
    if (pricing) {
      const options = filter(pricing || [], (val) => val?.category === 'OPTIONAL');
      const items = groupBy(options || [], 'invoice_item_type.units.total');
      setData(items);
    }
  }, [pricing]);

  /**
   * Table columns
   */
  const columns = [
    {
      name: i18n.t('subscriptions.item'),
      selector: 'invoice_item_type.name',
      cell: (row) => row?.invoice_item_type?.name || '--',
      minWidth: '140px',
    },
    {
      name: i18n.t('subscriptions.quantity'),
      selector: 'quantity',
      cell: (row) => 1,
      maxWidth: '100px',
    },
    {
      name: '',
      selector: 'total',
      cell: (row) =>
        row?.unit_price !== null
          ? `$${row?.unit_price / 100} ${row?.invoice_item_type?.units?.per_unit}`
          : '--',
    },
  ];

  return (
    <>
      {Object.keys(data).length
        ? Object.keys(data).map((key, index) => (
            <React.Fragment key={index}>
              <h5> {capitalize(key.trim())} </h5>
              <div
                style={{
                  margin: '10px 0',
                }}
              >
                <Table
                  data={data[key]}
                  columns={columns}
                  pagination={false}
                  paginationComponentOptions={{ noRowsPerPage: true }}
                />
              </div>
            </React.Fragment>
          ))
        : i18n.t('common.empty_list')}
    </>
  );
};

export default OptionalItemsTable;
